import React, { useEffect, useState } from 'react'

import { paths } from '@mc/paths'

import Link from 'components/Link'
import { getPrimarySubcategoryForOutcome } from 'libs/server/api'

import {
  trackOutcomePagesExperimentViewed,
  useOutcomePagesBucket,
} from '../utilities'

interface OutcomeLinkProps {
  className?: string
  outcomeSlug: string
  subcatSlug?: string
  children: React.ReactNode
  onClick?: (href: string) => void
}

export const OutcomeLink = ({
  className = '',
  outcomeSlug,
  subcatSlug,
  children,
  onClick,
}: OutcomeLinkProps) => {
  const { isVariant } = useOutcomePagesBucket()
  const [fallbackSubcatSlug, setFallbackSubcatSlug] = useState<
    string | undefined
  >()

  useEffect(() => {
    trackOutcomePagesExperimentViewed()
  }, [])

  useEffect(() => {
    const fetchAndSetFallbackSubcatSlug = async () => {
      if (!isVariant && !subcatSlug) {
        try {
          const slug = await getPrimarySubcategoryForOutcome(outcomeSlug)
          setFallbackSubcatSlug(slug)
        } catch (error) {
          setFallbackSubcatSlug(undefined)
        }
      }
    }

    fetchAndSetFallbackSubcatSlug()
  }, [isVariant, outcomeSlug, subcatSlug])

  const href = isVariant
    ? paths.outcomePage(outcomeSlug)
    : paths.outcomeOnSubcatPage(subcatSlug || fallbackSubcatSlug, outcomeSlug)

  if (!isVariant && !subcatSlug && !fallbackSubcatSlug) {
    // This should never happen, but if it does, we don't want to render the link
    return <span className={className}>{children}</span>
  }

  return (
    <Link className={className} onClick={() => onClick?.(href)} href={href}>
      {children}
    </Link>
  )
}
